<template>
    <!--说明书-->
    <div class="instruction">
        <top-menu :imgShow="imgShow" :pathName="pathName"/>

        <!--top-->
        <div class="top">
            <div :class="`${isApple == true ? 'index-cont-phone' : 'index-cont'}`"></div>

            <div class="top_title">使用全部说明</div>
        </div>

        <!--banner-->
        <Banner/>

        <!--tabs-->
        <div class="tabList">
            <div class="tabList_title">
                <span>使用说明手册查询</span>
                <img src="@/asstes/dataCenter/circular.png">
            </div>
            <div class="tabSelect" @click="handleSelect">
                <span>{{ selectName }}</span>
                <img src="@/asstes/dataCenter/down.png">
            </div>

            <div class="tabList_tabs">
                <div class="tabList_tabs_item" v-for="(item, index) in editionList.slice(0, 2)" :key="index"
                     @click="handleDetail(item)">
                    <img :src="item.productImgPath">
                    <div>{{ item.productName }}</div>
                </div>
            </div>
        </div>

        <el-drawer title="充电桩系列" :visible.sync="drawer" :direction="direction"
                   :modal="false" :show-close="false">
            <div class="edition">
                <div class="edition_item" v-for="(item, index) in editionList" :key="index">
                    <div @click=" handleItemSelect(item)"
                         :class="{'active': selectActive == item.productSerialId}">
                        <span>{{ item.productName }}</span>
                        <img :src="item.img" v-if="item.imgShow">
                    </div>
                </div>
            </div>
            <div class="edition_option">
                <div class="reset" @click="handleReset">重 置</div>
                <div class="makeSure" @click="makeSure">确 认</div>
            </div>
        </el-drawer>

    </div>
</template>

<script>
    import Banner from '../banner'
    import TopMenu from '../topmenu'
    export default {
        components:{
            Banner,
            TopMenu
        },
        data() {
            return {
                tabsList:[
                    {
                        id: 1,
                        img: require('@/asstes/findlist/instruction/first.png'),
                        name: '数字交流桩-基础版'
                    },
                    {
                        id: 2,
                        img: require('@/asstes/findlist/instruction/second.png'),
                        name: '数字交流桩-4G版'
                    },
                ],
                // 抽屉数据
                editionList: [],
                imgList: {
                    img: require('@/asstes/findlist/instruction/third.png'),
                    imgShow: false,
                },
                drawer: false,
                direction: 'btt',
                selectActive: null,
                selectName: '请选择充电桩型号',
                selectList: {},
                isApple: '',
                imgShow: true,
                pathName: 'findList'
            }
        },
        mounted() {
            this.appDown();
            this.getproductOption();
        },
        methods: {
            // 判断是安卓还是ios
            appDown() {
                let _ = this;
                let u = navigator.userAgent;
                let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if(isiOS){
                    _.isApple = true;
                    window.webkit.messageHandlers.hideTabbar.postMessage('');
                }else if(isAndroid){
                    _.isApple = false;
                    window.jsBridge.hideTabbar();
                }
            },
            // 获取充电桩型号
            getproductOption(){
                let that = this;
                that.$U.showLoading(that)
                that.$H.get(that, that.$A.knowledge.pileProductFindall,  {isDisplay:'Y'}).then(res => {
                    that.editionList = res.data.data.filter( li => {
                        return li.isDisplay == 'Y'  && li.productActiveStatus == '01'
                    })
                    that.editionList.forEach(li => {
                        return Object.assign(li, that.imgList)
                    })
                    that.$U.hideLoading(that);
                })
            },
            // 版本选择
            handleSelect(){
                let that = this;
                that.drawer = true;
            },
            // 详情页面
            handleDetail(row){
                let that = this;
                that.$router.push({
                    name: 'detail',
                    query:{ selectList: JSON.stringify(row) }
                })
            },

            handleItemSelect(row){
                let that = this;
                that.selectList = row
                that.selectActive = row.productSerialId;
                that.selectName = row.productName;
                that.editionList.forEach( li => {
                    if( row.productSerialId == li.productSerialId ){
                        li.imgShow = true;
                    } else {
                        li.imgShow = false;
                    }
                })
            },
            // 重置
            handleReset(){
                let that = this;
                that.selectActive = null;
                that.selectName = '请选择充电桩型号';
                that.selectList = {};
                that.editionList.forEach( li => {
                    return li.imgShow = false
                })
                that.close();
            },
            // 确认
            makeSure(){
                let that = this;
                that.editionList.forEach(li => {
                    if(li.imgShow){
                        that.handleDetail(that.selectList)
                        that.close();
                    }
                })
            },
            // 关闭
            close(){
                this.drawer = false;
            },
        },
    }
</script>

<style lang="less" scoped>


    .instruction{
        padding: 60px 25px 0 25px;
        box-sizing: border-box;

        .top{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            flex-wrap: wrap;
            padding-bottom: 32px;
            box-sizing: border-box;

            // ios 需要左箭头，
            .index-cont-phone{
                display: none;
            }
            // android 不需要左箭头，并往下移
            .index-cont{
                width: 100%;
                height: 32px;
            }

            .top_title{
                width: 100%;
                font-size: 24px;
                font-weight: 600;
            }

        }

        .tabList{
            display: flex;
            flex-wrap: wrap;

            .tabList_title{
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding-bottom: 24px;
                box-sizing: border-box;

                span{
                    padding-right: 10px;
                    box-sizing: border-box;
                    font-size: 14px;
                    line-height: 16px;
                }
                img{
                    width: 3%;
                }
            }

            .tabSelect{
                width: 100%;
                background-color: #1F2531;
                padding: 18px 16px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                span{
                    font-size: 14px;
                }
                img{
                    width: 5%;
                    transform: rotate(-90deg);
                }
            }

            .tabList_tabs{
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;
                margin-top: 24px;

                .tabList_tabs_item{
                    width: calc(50% - 12px);
                    background-color: #343D4E;
                    padding: 14px 16px;
                    box-sizing: border-box;
                    border-radius: 10px;
                    font-size: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    img{
                        width: 50%;
                    }
                    div{
                        padding-top: 16px;
                        box-sizing: border-box;
                    }
                }
                .tabList_tabs_item:first-child{
                    margin-right: 12px;
                }
                .tabList_tabs_item:nth-child(2){
                    margin-left: 12px;
                }
            }

        }

        /deep/ .el-drawer{
            background-color: #384357;
            color: #BDD0F1;
            border-top-left-radius: 32px;
            border-top-right-radius: 32px;
            height: auto!important;
        }
        /deep/ .el-drawer__header{
            color: #BDD0F1;
            font-size: 14px;
            padding: 25px;
            margin-bottom: 0;
        }
        /deep/ .el-drawer__body{
            padding: 0 15px;
            box-sizing: border-box;
        }

        .edition{
            font-size: 14px;

            .edition_item{
                margin: 8px 0;

                div{
                    width: 100%;
                    padding: 16px 15px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    img{
                        width: 6%;
                    }
                }

                .active{
                    background: #2D3748;
                    border-radius: 7px;
                }
            }
        }
        .edition_option{
            margin-top: 40px;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
            font-size: 14px;
            margin-bottom: 25px;
            padding: 0 12px;
            box-sizing: border-box;

            .reset{
                width: calc(50% - 12px);
                margin-right: 12px;
                height: 56px;
                line-height: 56px;
                border: 1px solid #0BBAB4;
                color: #0BBAB4;
                border-radius: 20px;
            }
            .reset:hover, .makeSure:hover{
                cursor: pointer;
            }
            .makeSure{
                width: calc(50% - 12px);
                margin-left: 12px;
                height: 56px;
                line-height: 56px;
                background-color: #0BBAB4;
                color: white;
                border-radius: 20px;
            }
        }
    }
</style>
